const SLUG = "outsourced-financial-management";

/**
 * The three shapes the engagement can take.
 *
 * Side by side on purpose: seeing "selected hours" next to "dedicated team"
 * is what explains why there is no single monthly price on this page.
 */
export const SupportLevels = ({ levels }) => (
  <section
    id="flexible-support"
    data-testid={`${SLUG}-levels`}
    className="scroll-mt-24 py-14 sm:py-20"
  >
    <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
      <h2 className="max-w-[34ch] text-[27px] font-bold leading-[1.15] tracking-[-0.015em] text-foreground sm:text-[34px]">
        A finance function that fits the way you work
      </h2>
      <p className="mt-4 max-w-[62ch] text-[15px] leading-relaxed text-muted-foreground sm:text-base">
        Choose the level of support that fits your current requirements, and scale the team as
        your needs change.
      </p>

      <div className="mt-9 grid grid-cols-1 gap-4 lg:grid-cols-3">
        {levels.map(({ title, text, detail, icon: Icon }, index) => (
          <article
            key={title}
            data-testid={`${SLUG}-level-${index + 1}`}
            className="tt-card relative flex flex-col overflow-hidden p-6"
          >
            <span
              aria-hidden="true"
              className="absolute inset-x-0 top-0 h-[3px] bg-[color:var(--tt-accent)]"
              style={{ opacity: 0.35 + index * 0.3 }}
            />
            <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-[color:var(--tt-accent)]/10 text-[color:var(--tt-accent)]">
              <Icon className="h-5 w-5" aria-hidden="true" />
            </span>
            <h3 className="mt-4 text-[13px] font-bold uppercase tracking-[0.1em] text-foreground">
              {title}
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-muted-foreground">{text}</p>
            <p className="mt-4 border-t border-border pt-4 text-[12.5px] font-medium text-[color:var(--tt-teal-deep)]">
              {detail}
            </p>
          </article>
        ))}
      </div>
    </div>
  </section>
);
